@if (loading()) {
  <app-loading></app-loading>
} @else {
  <div class="container">
    <div class="info-container">
      <img src="/imgs/icon.png" alt="">
      <div class="info">{{'share_log.info' | translate}}</div>
      <div class="sub-info">{{'share_log.sub_info' | translate}}</div>
    </div>

    <div class="selected-container">
      <div class="selected-list">
        @if (!activeUserPsychologist()) {
          <div class="selected-info">{{ 'share_log.select_pro' | translate }}</div>
        } @else {
          <div matRipple class="selected-item">
            <mat-icon>badge</mat-icon>
            <div class="selected-name">{{activeUserPsychologist()?.psychologists?.first_name + ' ' + activeUserPsychologist()?.psychologists?.last_name}}</div>
          </div>      
        }
      </div>
    </div>

    <div class="actions-container">
      <app-button
        [buttonLabel]="'buttons.not_share' | translate"
        [buttonType]="BUTTON_TYPES.OUTLINED" 
        [buttonDisabled]="false"
        (click)="skip()">
      </app-button>
      <app-button
        [buttonLabel]="'buttons.share' | translate"
        [buttonType]="BUTTON_TYPES.REGULAR" 
        [buttonDisabled]="!activeUserPsychologist()"
        (click)="share()">
      </app-button>
    </div>
  </div>
}
